import { FunctionComponent, useMemo, useEffect } from "react";
import Table from "../Table/Table";
import { Columns } from "../Table/ITable";
import CustomToolbar from "../Table/components/CustomToolbar";
import { GetRoleOptionType, UserPermissionProps } from "./IUserPermission";
import "./userPermission.scss";
import CustomFooter from "../Table/components/CustomFooter";
import ButtonField from "../Button/ButtonField";
import CommonCheckbox from "../Checkbox/CommonCheckbox";
import Select from "../withoutControllerComponents/Select/Select";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  updateUserPermission,
  userPermissionRowsList,
} from "../../Redux/Slices/UserPermission/UserPermissionRowsSlicer";
import { useSearchParams } from "react-router-dom";
import { AutocompleteOption } from "../Select/ISelectProps";
import { editUserPermission } from "../../Redux/Slices/UserPermission/UpdateUserPermissionSlicer";

const UserPermission: FunctionComponent<UserPermissionProps> = (props) => {
  const { rows, RoleOptions, YearOptions, getRoleOption } = props;
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );
  const userPermissionRowsDataUpdate = useAppSelector(
    (state) => state.EditUserPermission
  );

  const to = "settings";

  const adminRole = useMemo(() => {
    return RoleOptions.find(
      (role) => role.label?.toUpperCase() === "ADMIN"
    );
  }, [RoleOptions]);

  console.log(adminRole, "adminRoleadminRole")


  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[2];

  const selectedRoleId = Number(searchParams.get("id"));
  const selectedRole = RoleOptions.find(
    (role) => role.value === selectedRoleId
  );
  const isStudentRole = useMemo(() => {
    return (
      selectedRole?.label?.toLowerCase() === "student" ||
      selectedRole?.value?.toString() === "student"
    );
  }, [selectedRole]);

  useEffect(() => {
    const roleId = searchParams.get("id");

    if (!roleId && adminRole?.value) {
      setSearchParams({ id: String(adminRole.value) });
      // getRoleOption(adminRole);
    }
  }, [adminRole, searchParams, setSearchParams, getRoleOption]);


  // Column
  const column: Columns = [
    {
      field: "menuname",
      renderHeader: () => <b>Menus</b>,
      flex: 3,
      type: "string",
      align: "left",
      headerAlign: "center",
      maxWidth: 250,
    },
    {
      field: "view",
      renderHeader: () => <b>View</b>,
      flex: 1,
      type: "boolean",
      sortable: false,
      renderCell(params) {
        return (
          <div>
            <CommonCheckbox
              color="success"
              checked={params.value}
              // disabled={finaldata?.permissions?.edit === false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const checked = event.target.checked;
                dispatch(
                  updateUserPermission({
                    id: params.id,
                    row: {
                      ...params.row,
                      menu_id: params.id,
                      view: checked,
                      add: checked && params.row.add,
                      edit: checked && params.row.edit,
                      delete: checked && params.row.delete,
                    },
                  })
                );
                params.api.updateRows([
                  {
                    ...params.row,
                    menu_id: params.id,
                    view: checked,
                    add: checked && params.row.add,
                    edit: checked && params.row.edit,
                    delete: checked && params.row.delete,
                  },
                ]);
              }}
            />
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "add",
      renderHeader: () => <b>Add</b>,
      flex: 1,
      type: "boolean",
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell(params) {
        return (
          <div>
            <CommonCheckbox
              color="success"
              checked={params.value}
              // disabled={finaldata?.permissions?.edit === false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const checked = event.target.checked;
                dispatch(
                  updateUserPermission({
                    id: params.id,
                    row: {
                      ...params.row,
                      menu_id: params.id,
                      add: checked,
                      view: checked || params.row.view,
                    },
                  })
                );
                params.api.updateRows([
                  {
                    ...params.row,
                    menu_id: params.id,
                    add: checked,
                    view: checked || params.row.view,
                  },
                ]);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "edit",
      renderHeader: () => <b>Edit</b>,
      flex: 1,
      type: "boolean",
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell(params) {
        return (
          <div>
            <CommonCheckbox
              color="success"
              checked={params.value}
              // disabled={finaldata?.permissions?.edit === false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const checked = event.target.checked;
                dispatch(
                  updateUserPermission({
                    id: params.id,
                    row: {
                      ...params.row,
                      menu_id: params.id,
                      edit: checked,
                      view: checked || params.row.view,
                    },
                  })
                );
                params.api.updateRows([
                  {
                    ...params.row,
                    menu_id: params.id,
                    edit: checked,
                    view: checked || params.row.view,
                  },
                ]);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "delete",
      renderHeader: () => <b>Delete</b>,
      flex: 1,
      type: "boolean",
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell(params) {
        return (
          <div>
            <CommonCheckbox
              // disabled={finaldata?.permissions?.edit === false}
              color="success"
              checked={params.value}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const checked = event.target.checked;
                dispatch(
                  updateUserPermission({
                    id: params.id,
                    row: {
                      ...params.row,
                      menu_id: params.id,

                      delete: checked,
                      view: checked || params.row.view,
                    },
                  })
                );
                params.api.updateRows([
                  {
                    ...params.row,
                    menu_id: params.id,
                    delete: checked,
                    view: checked || params.row.view,
                  },
                ]);
              }}
            />
          </div>
        );
      },
    },
  ];
  const formattedRows = rows.map((item) => ({
    menu_id: item.id,
    active: item.active,
    add: item.add,
    edit: item.edit,
    view: item.view,
    delete: item.delete,
  }));

  useEffect(() => {
    if (userPermissionRowsDataUpdate?.data?.status_code === 200) {
      const roleId = searchParams.get("id");
      const yearId = searchParams.get("year");

      const payload: {
        roleId?: number;
        year_group_id?: number;
      } = {};

      if (roleId) payload.roleId = Number(roleId);
      if (yearId) payload.year_group_id = Number(yearId);

      dispatch(userPermissionRowsList(payload));
    }
  }, [userPermissionRowsDataUpdate?.data?.status_code, dispatch, searchParams]);

  return (
    <Table
      rows={rows}
      columns={column}
      exportFileName="User_Permissions"
      getRowId={(row) => row.id || row.menu_id}
    > <CustomToolbar className="top_toolbar">
        {/* <h6>User Permission</h6> */}
        <h6>User Permission</h6>
        <Select
          className="select_option"
          options={RoleOptions}
          value={
            RoleOptions.find(
              (role) => role.value === Number(searchParams.get("id"))
            ) ?? null
          }
          onChange={(_, v) => {
            getRoleOption(v as GetRoleOptionType);
            setSearchParams(
              (v as AutocompleteOption)?.value
                ? { id: (v as AutocompleteOption)?.value ?? null }
                : {}
            );
          }}
          label="Select Role"
          size="small"
          sx={{ minWidth: "300px" }}
        />
        {isStudentRole && (
          <Select
            className="select_option"
            options={YearOptions}
            value={
              YearOptions.find(
                (y) => y.value === Number(searchParams.get("year"))
              ) ?? null
            }
            onChange={(_, v) => {
              setSearchParams((prev) => {
                if ((v as AutocompleteOption)?.value) {
                  prev.set("year", String((v as AutocompleteOption).value));
                } else {
                  prev.delete("year");
                }
                return prev;
              });
            }}
            label="Select Year Group"
            size="small"
            sx={{ minWidth: "300px" }}
          />
        )}
      </CustomToolbar>
      <CustomFooter className="bottom_toolbar">
        <ButtonField
          variant="contained"
          sx={{
            "&:hover": {
              backgroundColor: "#009DFF", // Same color on hover to prevent change
            },
          }}
          onClick={() => {
            const roleId = searchParams.get("id");
            const yearId = searchParams.get("year");

            const payload: any = {
              roleId: roleId ? Number(roleId) : undefined,
              permissions: formattedRows,
            };

            // Only add yeargroup_country_map_id if selected
            if (isStudentRole && yearId && !isNaN(Number(yearId))) {
              payload.yeargroup_country_map_id = Number(yearId);
            }

            dispatch(editUserPermission(payload));
          }}
          disabled={
            !!!RoleOptions.find(
              (role) => role.value === Number(searchParams.get("id"))
            )
          }
        >
          Submit
        </ButtonField>
      </CustomFooter>
    </Table>
  );
};

export default UserPermission;